import { connect } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import { VENUE_SERVICE_TYPES, NEW_SERVICE_BANNER_LOCAL_STORAGE_KEY } from 'constants/logic';
import { providesService, IA_KEY } from 'helpers/ia-logic';
import { selectRouteParams, selectActiveVenue, selectIaLogic, selectUserId } from 'selectors/general';
import { getKeyForUser } from 'helpers/local-storage';
import { selectServices } from './Services/Services.selectors';
import { selectPractitioners } from './Practitioners/Practitioners.selectors';
import { selectResources } from './Resources/Resources.selectors';
import { hideServiceBanner } from './ManageServices.saga';

import ManageServices from './ManageServices';

function mapStateToProps(state, ownProps) {
  const { tab: activeTab } = selectRouteParams(state);
  const activeVenue = selectActiveVenue(state);
  const { isMsInventoryVenue, venueId, autosyncStatus } = activeVenue;
  const showAutoSyncStatus = providesService(activeVenue, VENUE_SERVICE_TYPES.APPOINTMENT) && autosyncStatus;
  const { featureIsSupported } = selectIaLogic(state, IA_KEY.MANAGE_SERVICES, venueId);
  const userId = selectUserId(state);
  const shouldShowBanner = getKeyForUser(userId, NEW_SERVICE_BANNER_LOCAL_STORAGE_KEY, false);

  return {
    ...ownProps,
    activeTab,
    isMsInventoryVenue,
    showAutoSyncStatus,
    featureIsSupported,
    isServicesEmpty: _isEmpty(selectServices(state)),
    isPractitionersEmpty: _isEmpty(selectPractitioners(state)),
    isResourcesEmpty: _isEmpty(selectResources(state)),
    shouldShowBanner,
    venueId,
  };
}

const mapDispatchToProps = {
  onBannerClose: hideServiceBanner,
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageServices);
